import { Button } from "@mui/material"
import { Box } from "@mui/system"
import { Link } from "react-router-dom"
import '../globals/entryFormStyles.scss'

interface NotFoundPropTypes {

}

const NotFound = (props : NotFoundPropTypes) => {
  return (
    <div>
        <h1
          style={{
            fontSize: "15em",
            margin: "0",
            textAlign: "center"
          }}
        >404</h1>
        <h6
          style={{
            fontSize: "2em",
            margin: "0",
            textAlign: "center"
          }}
          >Sorry, page not found</h6>

          <Box 
            width="100%"
            display={"flex"}
            justifyContent={"space-around"}
            marginTop={"35px"}
          >
            <Link to="/"><Button variant="contained" >Go back to where it's safe</Button></Link>
          </Box>
    </div>
  )
}

export default NotFound